import React from "react";
import { Link } from 'react-router-dom';



export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
            <div className="col-lg-10 col-md-offset-1 intro-text text-center">


                <h1 style={{ textTransform: 'none',fontWeight: 'bold',color: '#fff' }}>
                  {props.data ? props.data.title : "Loading"}
                </h1>
                {/* <h2 style={{ textTransform: 'none', fontSize: '65px', marginTop: '-30px',fontWeight: '700',color: '#fff',  fontFamily: "'Raleway', sans-serif"  // Buraya ne kullanıyorsan
 }}>
  Danışmanlık ve Eğitim
</h2> */}
<p style={{
  fontSize: '25px',
  marginTop: '85px',
  color: 'white',
  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
}}>
  <strong>{props.data ? props.data.paragraph : "Loading"}</strong>
</p>
                
                  <Link
                    to="/personality-analysis"
                    className="btn btn-custom btn-lg page-scroll"
                    style={{ marginTop: "-45px" }}
                    >
                    Teste Başla
                  </Link>


                {" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
